module.exports = __webpack_public_path__ + "img/pic-02.cf23b444.png";